import React, { useState } from "react";
import { Nav, Navbar, NavDropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import mobile from "../../assests/img/Asset 24.png";
import email from "../../assests/img/Asset 23.png";
import logo from "../../assests/img/kior logo.svg";
import nabhlogo from "../../assests/img/nabhlogo.png";

const Header = () => {

  const [showServices, setShowServices] = useState(false);
  const [expanded, setExpanded] = useState(false);

  const handleServicesToggle = (isOpen) => setShowServices(isOpen);
  const handleDropdownItemClick = () => {
    setShowServices(false);
  };

  const handleViewDetails = () => {
    setExpanded(false);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="navbar_inner">
      <div className="header_top">
        <div className="coustom_container">
          <div className="header_top_left">
            <div className="d-flex align-items-center">
              <Link to="/">
                <img src={logo} alt="logo" className="logo" />
              </Link>
              <img src={nabhlogo} alt="nabhlogo" className="logo nabh-logo" />
            </div>

            <div className="header_top_right_text">
              <Link to="contact-us" className="me-3">
                Contact Us
              </Link>
              <span className="me-3">
                <img src={mobile} alt="mobile-img" />
                +91 8263000004,+91 9875964159
              </span>
              <span className="me-3">
                <img src={email} alt="email-img" className="email_img" />{" "}
                kiorhealthcare8b@gmail.com
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="header_bottom_sec">
        <div className="coustom_container">
          <div className="header_bottom">
            <Navbar
              expand="lg"
              expanded={expanded}
              className="bg-body-tertiary"
            >
              <Navbar.Toggle
                aria-controls="basic-navbar-nav"
                onClick={() => setExpanded(expanded ? false : true)}
              />
              <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="me-auto">
                  <Nav.Link
                    as={Link}
                    to="/about-us"
                    onClick={handleViewDetails}
                  >
                    ABOUT US
                  </Nav.Link>
                  <NavDropdown
                    title="SERVICES"
                    id="services-nav-dropdown"
                    className="services-dropdown"
                    show={showServices}
                    onMouseEnter={() => setShowServices(true)}
                    onMouseLeave={() => setShowServices(false)}
                    onToggle={handleServicesToggle}
                  >
                    <NavDropdown.Item
                      as={Link}
                      to="/laboratory-tests-mohali"
                      onClick={() => {
                        handleDropdownItemClick();
                        handleViewDetails();
                      }}
                    >
                      Laboratory tests
                    </NavDropdown.Item>
                    <NavDropdown.Item
                      as={Link}
                      to="/ct-scan-mohali"
                      onClick={() => {
                        handleDropdownItemClick();
                        handleViewDetails();
                      }}
                    >
                      CT Scan
                    </NavDropdown.Item>
                    <NavDropdown.Item
                      as={Link}
                      to="/mri-scan-mohali"
                      onClick={() => {
                        handleDropdownItemClick();
                        handleViewDetails();
                      }}
                    >
                      MRI Scan
                    </NavDropdown.Item>
                    <NavDropdown.Item
                      as={Link}
                      to="/ultrasound-scan-mohali"
                      onClick={() => {
                        handleDropdownItemClick();
                        handleViewDetails();
                      }}
                    >
                      USG Scan
                    </NavDropdown.Item>
                    <NavDropdown.Item
                      as={Link}
                      to="/digital-xray-mohali"
                      onClick={() => {
                        handleDropdownItemClick();
                        handleViewDetails();
                      }}
                    >
                      X-Ray / BMD / Mammography{" "}
                    </NavDropdown.Item>
                    <NavDropdown.Item
                      as={Link}
                      to="/cardiology-tests-mohali"
                      onClick={() => {
                        handleDropdownItemClick();
                        handleViewDetails();
                      }}
                    >
                      Cardiology Tests
                    </NavDropdown.Item>
                    <NavDropdown.Item
                      as={Link}
                      to="/ecg-mohali"
                      onClick={() => {
                        handleDropdownItemClick();
                        handleViewDetails();
                      }}
                    >
                      ECG EEG NCV
                    </NavDropdown.Item>
                  </NavDropdown>
                  <Nav.Link
                    as={Link}
                    to="/health-packages-mohali"
                    onClick={handleViewDetails}
                  >
                    PACKAGES
                  </Nav.Link>
                  <Nav.Link
                    as={Link}
                    to="/contact-us"
                    onClick={handleViewDetails}
                  >
                    CONTACT US
                  </Nav.Link>
                  <Nav.Link as={Link} to="/faq" onClick={handleViewDetails}>
                    FAQ
                  </Nav.Link>
                  <Nav.Link
                    as={Link}
                    to="/feedback"
                    onClick={handleViewDetails}
                  >
                    FEEDBACK
                  </Nav.Link>
                </Nav>
              </Navbar.Collapse>
            </Navbar>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
